import type { LogLevel } from './types'

const isProduction = process.env.NODE_ENV === 'production'

export function formatLog(level: LogLevel, namespace: string, message: string, meta?: Record<string, unknown>): string {
  if (isProduction) {
    return JSON.stringify({
      level,
      ns: namespace,
      msg: message,
      ...meta,
      ts: new Date().toISOString()
    })
  }

  const metaStr = meta && Object.keys(meta).length > 0 ? ` ${JSON.stringify(meta)}` : ''
  return `[${namespace}] ${level}: ${message}${metaStr}`
}
